export const messages = {
  en: {
    attendanceClassesStaffManage: {
      search: {
        title: 'Search Conditions',
        staffName: 'Please enter staff name'
      },
      list: {
        title: 'Attendance Staff List'
      },
      table: {
        face: 'Face',
        staffId: 'Staff ID',
        staffName: 'Staff Name',
        createTime: 'Create Time'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this attendance staff?',
        success: 'Delete successfully',
        error: 'Delete failed'
      },
      fetchError: 'Failed to fetch attendance staff data',
      fetchClassError: 'Failed to fetch attendance classes data'
    }
  },
  zh: {
    attendanceClassesStaffManage: {
      search: {
        title: '查询条件',
        staffName: '请输入员工姓名'
      },
      list: {
        title: '考勤员工列表'
      },
      table: {
        face: '人脸',
        staffId: '员工编号',
        staffName: '员工名称',
        createTime: '创建时间'
      },
      delete: {
        title: '确认操作',
        confirmText: '确定删除该考勤员工吗？',
        success: '删除成功',
        error: '删除失败'
      },
fetchError: '获取考勤员工数据失败',
      fetchClassError: '获取考勤班次数据失败'
    }
  },
  'zh-TW': {
    attendanceClassesStaffManage: {
      search: {
        title: '查詢條件',
        staffName: '請輸入員工姓名'
      },
      list: {
        title: '考勤員工列表'
      },
      table: {
        face: '人臉',
        staffId: '員工編號',
        staffName: '員工名稱',
        createTime: '創建時間'
      },
      delete: {
        title: '確認操作',
        confirmText: '確定刪除該考勤員工嗎？',
        success: '刪除成功',
        error: '刪除失敗'
      },
      fetchError: '獲取考勤員工數據失敗',
      fetchClassError: '獲取考勤班次數據失敗'
    }
  }
}